<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <!-- 卡片主体(表单) -->
          <div class="md-layout card-form">
            <div class="md-layout-item md-size-20 md-xsmall-size-50 left-layout-item">
              <md-field>
                <label>{{$I18n("account_state")}}</label>
                <md-select v-model="formData.state">
                  <md-option :value="0">{{$I18n("all")}}</md-option>
                  <md-option :value="1">{{$I18n("open")}}</md-option>
                  <md-option :value="2">{{$I18n("overdue")}}</md-option>
                  <md-option :value="3">{{$I18n("disable")}}</md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout md-layout-item md-size-20">
              <div class="md-layout-item md-size-25">
                <md-button class= "left-icon md-info" @click="form_changeSearchData">
                  <md-icon>search</md-icon>
                  {{$I18n("search")}}
                </md-button>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <md-card-content>
          <add-button @click="table_addItem">{{$I18n("add_user")}}</add-button>
          <!-- 卡片主体(表格) -->
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('user_id')">{{ item.user_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('user_name')">
                {{ item.user_name }}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('company_name')">
                {{ item.comp_name }}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('role_name')">
                {{$router.history.current.query.lang == 'en' ?item.role_name :item.role_cn_name}}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('phone')">
                {{ item.user_phone }}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('account_state')">
                {{ item.account_state_name }}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('created_time')">
                {{ item.create_time }}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button
                  @click.stop
                  @click="table_editItem(item)"
                  class="md-just-icon md-round md-info left-icon"
                  ><md-icon>edit</md-icon></md-button
                >
                <md-button
                  @click.stop
                  @click="table_deleteItem(item)"
                  class="md-just-icon md-round md-danger md-info"
                  ><md-icon>close</md-icon></md-button
                >
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">
              {{$I18n("none_data")}}
            </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 卡片-表格-翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :right = "openModalType!=='delete'"
      :large = "openModalType==='import'"
      :submitBtn = "openModalType !=='import'"
      @submit= "modal_submit"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", modalData.Form.user_name)}}</div>
        <!-- 修改/添加弹窗 -->
        <div v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <md-field slot="date" :class="{'md-error' : modalData.Error.validity_time}">
              <el-date-picker
                class="md-date-form-item"
                align="left"
                v-model="modalData.Form.validity_time"
                prefixIcon="no"
                value-format="yyyy-MM-dd HH:mm:SS"
                :placeholder="$I18n('validity_time')"
                :end-placeholder="$I18n('end')">
              </el-date-picker>
              <md-icon :style="{'margin-right': 0}" v-if="modalData.Error.validity_time">clear</md-icon>
            </md-field>
          </common-form-item>
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { timestampToString,FormClass } from "@/common/tools.js";

export default {
  data() {
    return {
      // 表格相关
      ...({
        formData:{
          comp_id : "",
          search_type : 1,
          state : 0,
        },
        searchData : {
          comp_id : "",
          search_type : 1,
          state : 0,
        },
        icon  : "computer",
        title : this.$I18n("user"),
        tableInitData : [], // 表格数据
        compData : [], // 公司数据
        roleData : [],
        // 分页相关
        pageSize : 10,
        currentPage : 1,
        total : 0,
        // 弹窗相关
        openModal: false,  // 是否打开弹窗
        openModalType : "upload", // 弹窗类型
        modalTitle : "",  // 弹窗标题
      }),
      // 弹窗表单相关
      ...({
        modalData : new FormClass({
          comp_id  : "",
          user_id  : "",
          user_name: "",
          role_id  : "",
          user_password : "",
          confirm_password : "",
          user_email : "",
          user_phone : "",
          validity_time : "",
          state : 1,
          remark : "",
        },{
          user_id  : "required",
          user_name: "required",
          user_email : "required",
          user_phone : "required",
          validity_time : "required",
          user_password : (value,formValue,type) => {
            return type === "add" && !value;
          },
          confirm_password : (value, formValue) => {
            return  value != formValue.user_password;
          },
        }),
      })
    };
  },
  mounted : function() {
    this.api_getPageData();
    this.api_getComp()
      .then(this.api_getRole)
      .then(() => {
        this.modalData.SetInit(this.compData[0].comp_id, "comp_id");
        this.modalData.SetInit(this.roleData[0].id, "role_id");
      });
    
  },
  watch: {
    currentPage() {
      this.api_getPageData();
    },
  },
  computed: {
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return [...this.tableInitData]
          // .splice((this.currentPage-1) * this.pageSize, this.pageSize)
          .map(item => {
            // let role_name = "";
            // this.roleData.forEach(role_item => {
            //   if (item.role_id == role_item.id) {
            //     role_name = role_item.name;
            //   }
            // })
            let account_state_name = "";
            switch(item.state){
              case 3:
                account_state_name = this.$I18n("disable");
                break
              case 1:
                account_state_name = this.$I18n("open");
                break
              case 2:
                account_state_name = this.$I18n("overdue");
                break;
              default:
                account_state_name = this.$I18n("unknow");
                break;
            }
            let create_time = timestampToString(item.gmt_create * 1000)
            let validity_time = timestampToString(item.gmt_validity * 1000)


            return {
              // role_name,
              account_state_name,
              create_time,
              validity_time,
              ... item,
            }
          })
      }
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("company"),
          keys    : "comp_id",
          type    : "select",
          placeholder: this.$I18n('pls_input_role_id'),
          options : this.compData.map(i => {
            return {
              id  :i.comp_id,
              name:i.comp_name,
            }
          })
        },
        {
          label   : this.$I18n("user_id"),
          keys    : "user_id",
          type    : "input",
          required: true,
          check   : true,
          disabled: this.openModalType === "edit",
        },{
          label   : this.$I18n("login_name"),
          keys    : "user_name",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("user_role"),
          keys    : "role_id",
          type    : "select",
          options : this.roleData.map(i => {
            return {
              id  :i.id,
              name:this.$router.history.current.query.lang == 'en' ?i.name :i.cn_name,
            }
          })
        },{
          label   : this.$I18n("password"),
          keys    : "user_password",
          type    : "input",
          required: this.openModalType === 'add',
          check   : true,
        },{
          label   : this.$I18n("confirm_password"),
          keys    : "confirm_password",
          type    : "input",
          required: this.openModalType === 'add',
          check   : true,
        },{
          label   : this.$I18n("email"),
          keys    : "user_email",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("phone"),
          keys    : "user_phone",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("validity_time"),
          keys    : "date",
          required: true,
        },{
          label   : this.$I18n("account_state"),
          keys    : "state",
          type    : "radio",
          options : [
            {id: 1, name: this.$I18n("open")},
            {id: 3, name: this.$I18n("disable")},
          ],
        },
      ]
    },
  },
  methods: {
    form_changeSearchData(){
      this.searchData = {...this.formData}
      this.currentPage = 1;
      this.api_getPageData();
    },
    table_addItem(){
      this.modalTitle = this.$I18n("add");
      this.modalData.Reset();
      this.openModalType = "add";
      this.$refs.modal.open();
    },
    table_editItem(item){
      this.modalTitle = this.$I18n("edit");
      this.modalData.Update({
        ...item,
        user_password : "",
        confirm_password : "",
      });
      this.openModalType = "edit";
      this.$refs.modal.open();
    },
    table_deleteItem(item){
      this.modalTitle = this.$I18n("delete");
      this.modalData.Update(item);
      this.openModalType = "delete";
      this.$refs.modal.open();
    },
    // 获取公司信息
    api_getComp (){
      //获取菜单
      return this.$api.getCompanyList({})
        .then(this.$Then(res => {
          this.compData = res.data;
        }))
        .catch(this.$Catch("", () => {
          this.compData = [];
        }))
    },
    // 获取角色
    api_getRole (){
      //获取菜单
      return this.$api.getRoleList()
        .then(this.$Then(res => {
          this.roleData = res.data;
        }))
        .catch(this.$Catch("", () => {
          this.roleData = [];
        }))
    },
    // 获取页面信息
    api_getPageData(){
      // 获取角色
      // let page_no = this.currentPage;
      this.$api.getUserList({
        ...this.searchData,
        page_size : this.pageSize,
        page_index   : this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 隐藏 弹窗
    modal_classicModalHide () {
    },
    // 提交表单
    modal_submit () {
      if (this.openModalType !== "delete" && this.modalData.Check(this.openModalType)){
        if(this.modalData.ErrorList.includes("confirm_password") && this.modalData.ErrorList.length === 1){
          this.$errorMsg(this.$I18n("password_no_equal"));
          return
        }
        this.$errorMsg(this.$I18n("pls_input_content"));
        return;
      }
      this.modalData.Form.gmt_validity = new Date("2029-12-31 00:00:00").getTime() / 1000
      
      let apiPOST = new Promise(() => {});
      if(this.openModalType === "add"){
        apiPOST = this.$api.addUser({...this.modalData.Form})
      } else if (this.openModalType === "edit"){
        apiPOST = this.$api.editUser({...this.modalData.Form})
      } else if (this.openModalType === "delete"){
        apiPOST = this.$api.delUser({...this.modalData.Form})
      }
      apiPOST
        .then(this.$Then(res => {
          if(res.code === 200){
            this.$successMsg(this.$I18n("succ_num"));
            this.$refs.modal.close();
            this.api_getPageData();
          } else if (res.code === 1101) {
            this.$errorMsg(this.$I18n("error_code_1101"));
          } else if (res.code === 1102) {
            this.$errorMsg(this.$I18n("error_code_1102"));
          } else if (res.code === 1103) {
            this.$errorMsg(this.$I18n("error_code_1103"));
          } else if (res.code === 409){
            this.$errorMsg(this.$I18n("error_code_409"));
          }
        },[1101, 1102, 1103, 409]))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>